import { sortItems } from '@utils/functions.js';

import httpClient from './httpClient';
import { getUnlinkItemMap } from './mapper';

export const duplicateItem = (id, uid, items, setItems, setIsLoading) => {
  setIsLoading(true);
  httpClient.put(`api/blocks/item/copy/${id}`, { uid }).then((res) => {
    if (res && res.data) {
      setItems(sortItems([...items, res.data]));
    }
    setIsLoading(false);
  });
};

export const getPageBlocks = (id, profileId, setList, setIsLoading = () => {}) => {
  httpClient
    .get(`api/profiles/${profileId}/pages/${id}`)
    .then((res) => {
      if (res && res.data) {
        const { blocks: sections } = res.data;
        setList(sections);
      }
    })
    .catch((error) => {
      console.log(error);
    })
    .finally(() => {
      setIsLoading(false);
    });
};

export const getInstagramList = (username, userId, setList, setIsSavingUsername, toggleUsernameModal) => {
  if (!username || !userId) {
    return;
  }
  setIsSavingUsername(true);
  httpClient
    .post(`api/profiles/${profileId}/instagram-accounts2`, {
      profileId: userId,
      username,
    })
    .then((res) => {
      if (res && res.data) {
        const { data } = res;
        const items = data.mediaex.map((el) => getUnlinkItemMap(el));
        setList(items);
      }
      setIsSavingUsername(false);
      toggleUsernameModal();
    })
    .catch((error) => {
      console.log(error);
      setIsSavingUsername(false);
      toggleUsernameModal();
    })
    .finally(() => {
      setIsSavingUsername(false);
      toggleUsernameModal();
    });
};
export function getSectionHeadingPath(type, isPathDesign) {
  return isPathDesign ? `api/${type}-blocks/${blockId}/design` : `api/${type}-blocks/${blockId}`;
}

export function getUploadApiCall(formData, profileId) {
  return httpClient.post(`api/profiles/${profileId}/upload`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export function toggleBlockPin(profileId, blockId, isPinned) {
  return httpClient.post(`api/profiles/${profileId}/blocks/${blockId}/pin`, { isPinned });
}

export function archiveBlock(profileId, blockId) {
  return httpClient.delete(`api/profiles/${profileId}/blocks/${blockId}`);
}

export function restoreBlock(profileId, blockId) {
  return httpClient.put(`api/profiles/${profileId}/blocks/${blockId}/restore`);
}

export function getArchivedBlocks(profileId) {
  return httpClient.get(`api/profiles/${profileId}/blocks/archived`);
}

export function permanentDeleteBlock(profileId, blockId) {
  return httpClient.delete(`api/profiles/${profileId}/blocks/${blockId}/permanent`);
}
